export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20flatlay%20composition%20with%20carefully%20arranged%20clothing%20pieces%20including%20a%20tailored%20blazer%20folded%20knit%20sweater%20casual%20denim%20shirt%20and%20leather%20accessories%20scattered%20across%20a%20warm%20sand%20colored%20linen%20surface%20with%20soft%20diffused%20morning%20light%20from%20the%20left%20creating%20gentle%20directional%20shadows%20editorial%20lifestyle%20photography%20with%20rich%20textures%20and%20harmonious%20earth%20tone%20palette&width=1600&height=900&seq=hero-main-fresh-v2&orientation=landscape"
          alt="Superbuy Spreadsheet - Curated Fashion Collection"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/35"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6 max-w-4xl mx-auto">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight">
          The Best Superbuy Spreadsheet for<br />
          <span className="text-accent-300">Fashion &amp; Streetwear</span>
        </h1>
        <p className="mt-6 text-base md:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">
          Discover curated product links, verified sellers, and the most comprehensive superbuy spreadsheet for international buyers. Save time, save money, and shop with confidence.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-primary-500 text-white text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            superbuy spreadsheet
          </a>
          <a
            href="#categories"
            className="px-8 py-3.5 border-2 border-white/40 text-white text-sm font-semibold rounded-full hover:bg-white/10 hover:border-white/60 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Browse Categories
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <a href="#features" className="block text-white/60 hover:text-white/90 transition-colors cursor-pointer">
          <i className="ri-arrow-down-s-line text-2xl animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}